import { render, staticRenderFns } from "./NotificationPopover.vue?vue&type=template&id=c968ef90&scoped=true&"
import script from "./NotificationPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopover.vue?vue&type=style&index=0&id=c968ef90&prod&scoped=true&lang=css&"
import style1 from "./NotificationPopover.vue?vue&type=style&index=1&id=c968ef90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c968ef90",
  null
  
)

export default component.exports